import { convertDateFromStringToMoment, entityToLabelValue } from 'Core/utils'

import { PurchaseOrder } from 'Portals/Customer/entities'

export const formatBillingLocationAddressOption = (
	addr: PurchaseOrder.BillingLocationAddress
): LabelValue<number> => {
	const { customerName, addressLine1, addressLine2, city, state, zip, customerId } = addr

	const parts = [
		customerName,
		addressLine1,
		addressLine2,
		city,
		[state, zip].filter(Boolean).join(' ')
	]
		.filter(Boolean)
		.join(', ')

	return { label: parts, value: customerId }
}

export const getDefaultFormValues = (
	data: PurchaseOrder.Detailed,
	getCurrencyCodeByCustomerId: (customerId: BasicNumber) => BasicString,
	billingLocationAddressOptions: LabelValue<number>[]
): PurchaseOrder.Form => ({
	customerId: billingLocationAddressOptions?.find(
		(address) => address.value === data.customerId
	) as LabelValue<number>,
	serviceSitesIds: data.serviceSites.map(entityToLabelValue),
	purchaseOrderNumber: data.purchaseOrderNumber,
	amount: data.amountLeft,
	file: null,
	fileName: data.documentName,
	currency: getCurrencyCodeByCustomerId(data.customerId),
	effectiveStartDate: convertDateFromStringToMoment(data.effectiveStartDate),
	effectiveEndDate: convertDateFromStringToMoment(data.effectiveEndDate)
})
